const resolveDhlLabelPrintUrl = (raw: string): string => {
  if (!raw) return "";
  if (raw.startsWith("/")) {
    return `${process.env.VUE_APP_GENESIS_API_URL}${raw}`;
  }
  return raw;
};

export default resolveDhlLabelPrintUrl;
